import styled from "styled-components";

const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  gap: 1.5rem;
  width: 40ch;
  > div {
    width: 100%;
  }
`;

export default AuthForm;
